
/*
 *  Adds current url as a referrer attribute to user session links
 */
module.exports = Groupon.SharedJS.addReferrer = (function() {
  return {
    init: function() {
      var current_href, flags, ref1, referrer, selector;
      selector = '';
      flags = (ref1 = Groupon.PageFlags) != null ? ref1 : {};
      selector = flags.isTouch ? '#t-sign-in, #t-sign-out, .t-login-button' : '#ls-user-signin, #ls-user-signup, #sign-out';
      current_href = location.href;
      current_href = current_href.replace(location.hash, '');
      current_href = current_href.replace(/[?&](ref|return_to)=([^&]*)?/, '');
      referrer = 'return_to=' + encodeURIComponent(current_href);
      return $(selector).each(function() {
        var ref;
        ref = /\?/.test(this.href) ? '&' : '?';
        ref += referrer;
        return this.href += ref;
      });
    }
  };
})();

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL3NoYXJlZC91c2VyU2Vzc2lvbkFkZFJlZmVycmVyLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvY29yZS9mcm9udGVuZC9zaGFyZWQvdXNlclNlc3Npb25BZGRSZWZlcnJlci5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBOzs7QUFHQSxNQUFNLENBQUMsT0FBUCxHQUFpQixPQUFPLENBQUMsUUFBUSxDQUFDLFdBQWpCLEdBQWtDLENBQUEsU0FBQTtTQUNqRDtJQUFBLElBQUEsRUFBTSxTQUFBO0FBQ0osVUFBQTtNQUFBLFFBQUEsR0FBVztNQUNYLEtBQUEsK0NBQTRCO01BRTVCLFFBQUEsR0FDSyxLQUFLLENBQUMsT0FBVCxHQUNFLDBDQURGLEdBR0U7TUFFSixZQUFBLEdBQWUsUUFBUSxDQUFDO01BR3hCLFlBQUEsR0FBZSxZQUFZLENBQUMsT0FBYixDQUFxQixRQUFRLENBQUMsSUFBOUIsRUFBb0MsRUFBcEM7TUFHZixZQUFBLEdBQWUsWUFBWSxDQUFDLE9BQWIsQ0FBcUIsOEJBQXJCLEVBQXFELEVBQXJEO01BRWYsUUFBQSxHQUFXLFlBQUEsR0FBZSxrQkFBQSxDQUFtQixZQUFuQjthQUMxQixDQUFBLENBQUUsUUFBRixDQUFXLENBQUMsSUFBWixDQUFpQixTQUFBO0FBQ2YsWUFBQTtRQUFBLEdBQUEsR0FBUyxJQUFJLENBQUMsSUFBTCxDQUFVLElBQUMsQ0FBQSxJQUFYLENBQUgsR0FBeUIsR0FBekIsR0FBa0M7UUFDeEMsR0FBQSxJQUFPO2VBQ1AsSUFBQyxDQUFBLElBQUQsSUFBUztNQUhNLENBQWpCO0lBbkJJLENBQU47O0FBRGlELENBQUEsQ0FBSCxDQUFBIn0=
